import getDocument from './getDocument';
export const isFullscreenEditorLayout = () => {
  // eslint-disable-next-line hubspot-dev/no-private-classes
  const fullScreenLayoutSelector = '.space-sword--editor';
  return getDocument().querySelector(fullScreenLayoutSelector) !== null;
};